/**
 * Utility functions for handling images and media URLs
 */
import { getApiBaseUrl } from '../config/apiConfig';

const apiBaseUrl = () => getApiBaseUrl();

/**
 * Get the full URL for a profile picture
 * @param {string|null} profilePicture - The profile picture path from the backend
 * @returns {string|null} - The full URL to the profile picture or null if no picture
 */
export const getProfilePictureUrl = (profilePicture) => {
  if (!profilePicture) return null;

  // Debug logging in development
  if (process.env.NODE_ENV === 'development') {
    console.log('🖼️ Profile Picture URL Input:', profilePicture);
  }

  let finalUrl;

  // If it's already a full URL, return as is
  if (profilePicture.startsWith('http://') || profilePicture.startsWith('https://')) {
    finalUrl = profilePicture;
  }
  // If it's a relative URL starting with /, prepend the backend URL
  else if (profilePicture.startsWith('/')) {
    finalUrl = `${apiBaseUrl()}${profilePicture}`;
  }
  // If it's just a filename, prepend the media URL
  else {
    finalUrl = `${apiBaseUrl()}/media/${profilePicture}`;
  }

  // Debug logging in development
  if (process.env.NODE_ENV === 'development') {
    console.log('🖼️ Profile Picture URL Output:', finalUrl);
  }

  return finalUrl;
};

/**
 * Get the backend media URL
 * @returns {string} - The backend media URL
 */
export const getMediaUrl = () => {
  return `${apiBaseUrl()}/media/`;
};

/**
 * Get the backend base URL
 * @returns {string} - The backend base URL
 */
export const getBackendUrl = () => {
  return apiBaseUrl();
};
